import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { navGuardService } from 'features/common/utils/navGuardService';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'react-toastify/dist/ReactToastify.css';
import './styles/punchup-tokens.css';
import './styles/punchup-typography.css';
import './styles/punchup-button.css';
import './styles/punchup-forms.css';
import './styles/punchup-utilities.css';
import './styles/punchup-chart-card.css';
import './styles/punchup-animations.css';

import UseScrollToTop from 'hooks/useScrollToTop';
import { persistor, store } from 'store';
import { StyledThemeProvider } from 'theme';
import App from 'App';
import reportWebVitals from './reportWebVitals';
import './locals/i18n';

// Scope `color-scheme: light` (defined in punchup-tokens.css) to the iframe surface only: tag <html>
// when the app launches inside the Punchup iframe (`?isPunchup` is the source of the isPunchup flag),
// so the STANDALONE dark site's native controls (scrollbars, autofill, native <select>/date, number
// spinners) are not forced into light mode. Synchronous + pre-render to avoid any flash; the iframe's
// behaviour is unchanged (it always launches with the param).
if (new URLSearchParams(window.location.search).get('isPunchup') === 'true') {
	document.documentElement.setAttribute('data-punchup', 'true');
}

export const queryClient = new QueryClient({
	defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

ReactDOM.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<StyledThemeProvider>
				<BrowserRouter getUserConfirmation={(message, callback) => navGuardService.request(message, callback)}>
					<Provider store={store}>
						<PersistGate loading={null} persistor={persistor}>
							<UseScrollToTop />
							<App />
							<ToastContainer className="toast-container" />
						</PersistGate>
					</Provider>
				</BrowserRouter>
			</StyledThemeProvider>
			{/* <ReactQueryDevtools initialIsOpen={true} /> */}
		</QueryClientProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
